import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, Outlet } from "react-router-dom";
import ApiMessage from "./APIMessage";
import RandomSalesQuote from "./Loading";

import { auth, db } from "../Firebase/firebaseClient";
import { collection, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
// import SocialMedia from "./SocialMedia";

const ComposeNewAd = () => {
  const [value, setValue] = useState("");
  const [reply, setReply] = useState("");
  const [Suburb, setSuburb] = useState("");
  const [SuburbValue, setSuburbValue] = useState("");
  const [houseArea, setHouseArea] = useState("")
  const [landArea, setLandArea] = useState("")
  const [size, setSize] = useState("");
  const [isLoading, setIsLoading] = useState(false);
   // eslint-disable-next-line
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  // eslint-disable-next-line
  const [editableReply, setEditableReply] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [autoFocus, setAutoFocus] = useState(false);
  const inputRef = useRef(null);

  const emailContent = () => {
    const subject = encodeURIComponent("My Ad Text");
    const body = encodeURIComponent(reply);
    const mailtoLink = `mailto:?subject=${subject}&body=${body}`;

    window.open(mailtoLink, "_blank");
  };

  const handleImageUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const formData = new FormData();
      formData.append('image', file);
  
      try {
        setIsLoading(true);
        const response = await fetch('https://adtextai-usserver.onrender.com/upload-image', {
          method: 'POST',
          body: formData,
        });
  
        // Ensure response is in JSON format
        const data = await response.json();
        if (response.ok) {
          setImageUrl(data.imageUrl);
        } else {
          console.error('Error uploading image:', data.error);
        }
        setIsLoading(false);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    } else {
      console.error('No file selected');
    }
  };
  

  const GenerateText = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true); // Set loading to true before making the request
      const response = await fetch(
        "https://adtextai-usserver.onrender.com/compose-new-ad",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          },
          body: JSON.stringify({
            value,
            Suburb,
            SuburbValue,
            size,
            imageUrl,
            houseArea,
            landArea, 
          }),
        }
      );
      console.log(response.status);
      const data = await response.json();
      setReply(data.content);
      setIsLoading(false); // Set loading to false after receiving the response
    } catch (error) {
      console.error(error);
      setIsLoading(false); // Set loading to false in case of error
    }
  };

  const ReduceTextAction = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const response = await fetch(
        "https://adtextai-usserver.onrender.com/reduce-text",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorisation: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          },
          body: JSON.stringify({
            reply,
          }),
        }
      );
      console.log(response.status);
      const data = await response.json();
      setReply(data.content);
      setIsLoading(false); // Set loading to false after receiving the response
    } catch (error) {
      console.error(error);
      setIsLoading(false); // Set loading to false in case of error
    }
  };

  //this is were ill put the create social media post

  const SaveContent = async (user) => {
    try {
      const userDocRef = doc(db, "newUsers", user.uid);
      const userDocSnapshot = await getDoc(userDocRef);

      if (userDocSnapshot.exists()) {
        const userDocData = userDocSnapshot.data();

        if (userDocData.favorites && !userDocData.favorites.includes(reply)) {
          const updatedFavorites = [...userDocData.favorites, reply];
          await updateDoc(userDocRef, { favorites: updatedFavorites });
          alert("Content saved successfully!");
        } else if (!userDocData.favorites) {
          await updateDoc(userDocRef, { favorites: [reply] });
          alert("Content saved successfully!");
        } else {
          alert("Content is already saved.");
        }
      } else {
        await setDoc(userDocRef, { favorites: [reply] });
        alert("Content saved successfully!");
      }
    } catch (error) {
      console.error("Error saving content:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
   
      GenerateText(e);
   ;
  };

  const handleClickOutside = (e) => {
    if (inputRef.current && !inputRef.current.contains(e.target)) {
      handleSave();
    }
  };

  const handleSave = () => {
    setEditableReply(reply);
    setIsEditing(false);
  };

  const handleEdit = (e) => {
    setReply(e.target.value);
    console.log(reply);
  };

  const [subscription, setSubscription] = useState(null); // State to hold user's subscription
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const fetchSubscription = async () => {
        try {
            const currentUser = auth.currentUser;
            if (currentUser) {
                const userDocRef = doc(db, 'customers', currentUser.uid);
                const subscriptionsCollectionRef = collection(userDocRef, 'subscriptions');
                const activeSubscriptionsQuery = query(subscriptionsCollectionRef, where('status', 'in', ['active', 'trialing']));
                const activeSubscriptionsSnapshot = await getDocs(activeSubscriptionsQuery);

                if (!activeSubscriptionsSnapshot.empty) {
                    setSubscription(true);
                } else {
                    setSubscription(false);
                }
            }
        } catch (error) {
            console.error('Error fetching subscription:', error);
        }
    };

    fetchSubscription();
}, []);

  const handleEditToggle = () => {
    if (subscription) {
      setIsEditing(!isEditing);
      setAutoFocus(true);
    } else {
      setShowPopup(true);
    }
  };
  const navigate = useNavigate();

  const goToSavedAds = () => {
    if (subscription) {
      navigate("/user-SavedContent");
      // window.location="/user-SavedContent";
    } else {
      setShowPopup(true);
    }
  };

  const postToSocialMedia = () => {};

  useEffect(() => {
    if (isEditing) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [isEditing]);

  return (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <label>
          <textarea
            className="inputBox inputTextArea"
            type="text"
            value={value}
            placeholder="Write all the KEY features of the property"
            onChange={(e) => setValue(e.target.value)}
          />
          <input
            className="inputBox"
            type="text"
            placeholder="House area: m²"
            value={houseArea}
            onChange={(e) => setHouseArea(e.target.value)}
          />
          <input
            className="inputBox"
            type="text"
            placeholder="Land area: m²/Ha/Acre"
            value={landArea}
            onChange={(e) => setLandArea(e.target.value)}
          />
          <input
            className="inputBox"
            type="text"
            placeholder="Suburb"
            value={Suburb}
            onChange={(e) => setSuburb(e.target.value)}
          />
          
          <input
            className="inputBox"
            type="text"
            placeholder="Family/Investor/Luxury"
            value={SuburbValue}
            onChange={(e) => setSuburbValue(e.target.value)}
          />
         
        <select className="inputBox" onChange={(e) => setSize(e.target.value)}>
          <option value="70">Select Size</option>
          <option value="70">1/4 Page Ad</option>
          <option value="150">1/2 Page Ad</option>
          <option value="400">Full Page Ad</option>
        </select>
        <br />
        <input
            className="inputBox"
            type="file"
            accept="image/*"
            onChange={(e) => handleImageUpload(e)}
          />
      
        </label>
        
      </form>

      <br />
      <br />
      {showPopup && (
        <div className={"popup" + (showPopup ? " visible " : "")}>
          <div className="popup-content">
            <span className="close" onClick={() => setShowPopup(false)}>
              <div className="closeButton">&times;</div>
            </span>
            <p>Premium feature! Get Full Access Now!</p>
            <br />
            <Link className="createNewButton" to="/register">
              Subscribe
            </Link>
          </div>
        </div>
      )}

      {isLoading ? (
        <div className="loadingData">
          <RandomSalesQuote />
        </div>
      ) : (
        <>
          {isEditing ? (
            <textarea
              className="responseBox edit"
              ref={inputRef}
              type="text"
              value={reply}
              onChange={handleEdit}
              onBlur={handleSave}
              autoFocus={autoFocus}
            />
          ) : (
            <div>
              <ApiMessage
                speed={10}
                reply={reply}
                save={() => SaveContent(auth.currentUser)}
                handleSubmit={handleSubmit}
                emailContent={emailContent}
                handleEditToggle={handleEditToggle}
                isEditing={isEditing ? "Cancel" : "Edit"}
                reduce={ReduceTextAction}
                postToSocialMedia={postToSocialMedia}
                savedAds={goToSavedAds}
              />
        

              {/* <SocialMedia/> */}
            </div>
          )}
        </>
      )}

      <Outlet />
    </div>
  );
};

export default ComposeNewAd;
